import React from 'react';
import { Routes, Route} from 'react-router-dom';
import Admin from '../Admin';
import AdminDashboard from '../AdminDashboard/AdminDashboard';
import AdminLogin from '../AdminLogin/AdminLogin';


export default function AdminRoutes(){

    return(
        <Routes>
            <Route element={<Admin/>}>
                <Route index element={<AdminLogin/>} />
            </Route>
        </Routes>
    )
}